import { render, staticRenderFns } from "./FormForkLift.vue?vue&type=template&id=b3a148aa&scoped=true"
import script from "./FormForkLift.vue?vue&type=script&lang=js"
export * from "./FormForkLift.vue?vue&type=script&lang=js"
import style0 from "./FormForkLift.vue?vue&type=style&index=0&id=b3a148aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a148aa",
  null
  
)

export default component.exports